<template lang="pug">
el-dialog(
  :title="title"
  :visible.sync="localVisible"
  :before-close="onClose"
  v-loading="loading"
  width="60%"
)
  el-row
    el-col
      h4(v-show="refundModal") ¿Está seguro de que quiere pagar?
      el-row(v-show="responseModal")
        el-col(:span="3") Rango de fechas:
        el-col(:span="3" :offset="0") Desde
        el-col(:span="3") Hasta
      el-row(v-show="responseModal")
        el-col(:span="3" :offset="3") <span v-text="dateRange[0]"></span>
        el-col(:span="3") <span v-text="dateRange[1]"></span>
      el-row(v-show="refundModal")
        el-col(:span="8" :offset="8") Desde
        el-col(:span="8") Hasta
      el-row(v-show="refundModal")
        el-col(:span="8") Rango de fechas:
        el-col(:span="8") <span v-text="dateRange[0]"></span>
        el-col(:span="8") <span v-text="dateRange[1]"></span>
      template(v-if="refundData.type === 'fintoc' || refundData.type === 'mercado_pago'")
        div(v-show="refundModal")
          el-row
            el-col(:span="8") Cantidad de {{ entity.toLowerCase() }}:
            el-col(:span="8") <span v-text="refundData.count"></span>
          el-row
            el-col(:span="8") Monto total:
            el-col(:span="8") <span v-text="refundData.total"></span>
      template(v-else)
        div(v-show="refundModal")
          el-divider
          el-row
            el-col(:span="8") Cantidad de {{ entity.toLowerCase() }} TBK:
            el-col(:span="8") <span v-text="refundData.transbank.count"></span>
          el-row
            el-col(:span="8") Monto total TBK:
            el-col(:span="8") <span v-text="refundData.transbank.total"></span>
          el-divider
          el-row
            el-col(:span="8") Cantidad de {{ entity.toLowerCase() }} Oneclick:
            el-col(:span="8") <span v-text="refundData.oneclick.count"></span>
          el-row
            el-col(:span="8") Monto total Oneclick:
            el-col(:span="8") <span v-text="refundData.oneclick.total"></span>
      el-row(:gutter="12" v-show="responseModal" style="margin: 25px 0")
        template(v-if="refundData.type === 'fintoc'")
          el-col(:span="8")
            el-card
              el-result(icon="info")
                template(slot="extra")
                  el-descriptions
                    el-descriptions-item(:label="`Total ${entity}`") {{ refundData.response.count }}
                  el-descriptions
                    el-descriptions-item(label="Monto Total") {{ refundData.response.total }}
          el-col(:span="8")
            el-card
              el-result(icon="success")
                template(slot="extra")
                  el-descriptions
                    el-descriptions-item(
                      label="Reembolsos Creados") {{ refundData.process.count }}
                  el-descriptions
                    el-descriptions-item(label="Monto Total") {{ refundData.process.total }}
          el-col(:span="8")
            el-card
              el-result(icon="error")
                template(slot="extra")
                  el-descriptions
                    el-descriptions-item(
                      :label="`${entity} Rechazad${gender}s`") {{ refundData.reject.count }}
                  el-descriptions
                    el-descriptions-item(label="Monto Total") {{ refundData.reject.total }}
        template(v-else-if="refundData.type === 'mercado_pago'")
          el-col(:span="8")
            el-card
              el-result(icon="info")
                template(slot="extra")
                  el-descriptions
                    el-descriptions-item(:label="`Total ${entity}`") {{ refundData.response.count }}
                  el-descriptions
                    el-descriptions-item(label="Monto Total") {{ refundData.response.total }}
          el-col(:span="8")
            el-card
              el-result(icon="success")
                template(slot="extra")
                  el-descriptions
                    el-descriptions-item(
                      :label="`${entity} Pagad${gender}s`") {{ refundData.refund.count }}
                  el-descriptions
                    el-descriptions-item(label="Monto Total") {{ refundData.refund.total }}
          el-col(:span="8")
            el-card
              el-result(icon="error")
                template(slot="extra")
                  el-descriptions
                    el-descriptions-item(
                      :label="`${entity} Rechazad${gender}s`") {{ refundData.reject.count }}
                  el-descriptions
                    el-descriptions-item(label="Monto Total") {{ refundData.reject.total }}
        template(v-else)
          el-col(:span="8")
            el-card
              el-result(icon="info")
                template(slot="extra")
                  el-descriptions
                    el-descriptions-item(
                      :label="`Total ${entity} TBK`"
                    ) {{ refundData.transbank.response.count }}
                  el-descriptions
                    el-descriptions-item(
                      label="Monto Total TBK"
                    ) {{ refundData.transbank.response.total }}
                  el-divider
                  el-descriptions
                    el-descriptions-item(
                      :label="`Total ${entity} Oneclick`"
                    ) {{ refundData.oneclick.response.count }}
                  el-descriptions
                    el-descriptions-item(
                      label="Monto Total Oneclick"
                    ) {{ refundData.oneclick.response.total }}
          el-col(:span="8")
            el-card
              el-result(icon="success")
                template(slot="extra")
                  el-descriptions
                    el-descriptions-item(
                      :label="`${entity} TBK Pagad${gender}s`"
                    ) {{ refundData.transbank.refund.count }}
                  el-descriptions
                    el-descriptions-item(label="Monto Total TBK"
                  ) {{ refundData.transbank.refund.total }}
                  el-divider
                  el-descriptions
                    el-descriptions-item(
                      :label="`${entity} Oneclick Pagad${gender}s`"
                    ) {{ refundData.oneclick.refund.count }}
                  el-descriptions
                    el-descriptions-item(
                      label="Monto Total Oneclick"
                    ) {{ refundData.oneclick.refund.total }}
          el-col(:span="8")
            el-card
              el-result(icon="error")
                template(slot="extra")
                  el-descriptions
                    el-descriptions-item(
                      :label="`${entity} TBK Rechazad${gender}s`"
                    ) {{ refundData.transbank.reject.count }}
                  el-descriptions
                    el-descriptions-item(
                      label="Monto Total TBK"
                    ) {{ refundData.transbank.reject.total }}
                  el-divider
                  el-descriptions
                    el-descriptions-item(
                      :label="`${entity} Oneclick Rechazad${gender}s`"
                    ) {{ refundData.oneclick.reject.count }}
                  el-descriptions
                    el-descriptions-item(
                      label="Monto Total Oneclick"
                    ) {{ refundData.oneclick.reject.total }}
  el-row.inline-form__actions
    el-button(type="primary" @click.prevent="onConfirm" v-show="refundModal") Aceptar
    el-button(type="danger" @click="onClose" v-show="refundModal") Cancelar
    el-button(type="primary" @click="onClose" v-show="responseModal") Aceptar
</template>

<script>
export default {
  name: 'RefundModal',
  props: {
    title: String,
    entity: String,
    gender: String,
    visible: Boolean,
    loading: Boolean,
    refundModal: Boolean,
    responseModal: Boolean,
    dateRange: Array,
    refundData: Object,
  },
  data() {
    return {
      localVisible: this.visible,
    };
  },
  watch: {
    visible(newVal) {
      this.localVisible = newVal;
    },
  },
  methods: {
    onConfirm() {
      this.$emit('confirm');
    },
    onClose() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.inline-form__actions {
  margin-top: 20px;
}
</style>
